<template>
    <a class="dropdown-item delete-btn" @click="onClickDelete" :id="deleteButtonId">
        Delete
    </a>
</template>

<script>

export default {
    name: "bedDeleteComponent",
    props: ["userId", "bedId", "roomId"], // vue can read kebab props as camel cased vars    

    setup() {
    },

    data() {  
       
        var endpointToUse = location.protocol + "//" + window.location.host + "/api/beds/" + this.bedId + "/" + '6m8geptupkijwghd7xkya6wbjkrqo1wwpuuhmzzuuqhqhovy2mclfumdkccg';
  
        return {
            endpoint: endpointToUse,
            deleteButtonId: "delete-btn-"+this.bedId,
        };
    },

    validations() {  
    },

    computed: {     
    },

    methods: {
        onClickDelete: function () { 
         
            // Initialize alerts and toast notifications for displaying message  
            const toastError = Swal.mixin({          
                    toast: true,                
                    position: 'top-end', 
                    showConfirmButton: true, 
                });  
            const alertSuccess = Swal.mixin({                          
                    position: 'center', 
                    showConfirmButton: true, 
                    timer: 3000,
                    timerProgressBar: true,
                });
            const confirmDelete = Swal.mixin({                          
                    position: 'center', 
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it",
                    cancelButtonText: "Cancel",
                });
            const formData = {};
            
            // Show button spinner
            document.getElementById('delete-btn-'+this.bedId).innerHTML  = '<i class="fa fa-circle-notch fa-spin"></i>';
            document.getElementById('delete-btn-'+this.bedId).disabled  = true;                   

            confirmDelete.fire({
                title: "Are you sure?",
                text: "Clicking yes will delete the bed",
                icon: "warning",                    
            }).then((result) => {
                if (result.isConfirmed) {
                    // Add userID            
                    formData['userID'] = this.userId;
                    formData['roomID'] = this.roomId;
                    
                    // Remove the bed
                    this.deleteBed(formData, toastError, alertSuccess);
                }
            }); 

            // Show button spinner
            document.getElementById('delete-btn-'+this.bedId).innerHTML  = 'Delete';
            document.getElementById('delete-btn-'+this.bedId).disabled  = false;                   

    
        },


        deleteBed: function(formData, toastError, alertSuccess) {    
            
            // Call the update endpoint
            axios.delete(this.endpoint, { data: formData }) //delete doesn't support
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the bed object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            }); 
                            
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                                // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the bed object was deleted from the DB
                            this.formSuccess = true                          
                            alertSuccess.fire({
                                title: "Success!",
                                text: "The bed has been deleted.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/rooms/"+formData['roomID'];
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'error', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        },

    },
};
</script>
